import {combineReducers} from 'redux';  
import teslaAuthStatus from './teslaAuthStatusReducer';
import departureSchedules from './departureSchedulesReducer';
import teslaVehicles from './teslaVehiclesReducer';
import subscriptions from './subscriptionsReducer';
import preferences from './preferencesReducer';
import departureCalendars from './departureCalendarsReducer';

import * as types from '../actions/actionTypes';

const appReducer = combineReducers({  
	// short hand property names
	teslaAuthStatus,
	departureSchedules,
	teslaVehicles,
	subscriptions,
	preferences,
	departureCalendars,
})

const rootReducer = (state, action) => {
	if (action.type === types.LOG_OUT) {
		state = undefined
	}
	
	return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js